import React from 'react';
import loader from '../../assets/nesiya-loader.gif';

import './Loader.scss';

function Loader() {
    return (
        <div className="loader-container">
            <img src={loader} alt='' />
        </div>
    )
}

export default Loader
